import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import axios from "../../../../../../axios";
import "../../../Draft/Draft_Assess_Box/Draft_Q_list/Draft_Q_list_HW.css";
import DeleteConfirmation from "../../../Published/Published_Q_list/PublishQuestionType/DeleteConfirmation/DeleteConfirmation";
import DefaultQuestion from "../../../../Create_Assessment/Create_Question/Create_Q_Type/DefaultQuestion";
import QuestionList from "../../../../Create_Assessment/Preview_Question_List/QuestionListHomework";
import UpdateQuestions from "../../../../../../Components/QuestionEditCreate/UpdateQustion";
import OperationType from "../../../../../../Enum/OperationTypeEnum";
import ComponentType from "../../../../../../Enum/ComponentTypeEnum";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { Box, Dialog, DialogContent, Typography } from "@mui/material";

export default function Draft_Q_list_HW({ componentType }) {
  const [delete1, setDelete1] = useState(false);
  const [deactiveProcess, setDeactiveProcess] = useState(false);
  const [isInProgress, setIsInProgress] = useState(false);
  const [questionType, setQuestionType] = useState([]);
  const [countSkills, setCountSkills] = useState([]);
  const [countDifficulty, setCountDifficulty] = useState([]);
  const [countQsType, setCountQsType] = useState([]);
  const [isloading, setIsLoading] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [getErrorMsg, setGetErrorMsg] = useState("");
  const [openPopupDupli, setOpenPopupDupli] = useState(false);
  const [isopenPopupDupli, isSetOpenPopupDupli] = useState(false);
  const [viewErrorMsg, setViewErrorMsg] = useState("");
  const [hidePopupCheck, setHidePopupCheck] = useState(false);
  const [showErrorInputField, setShowErrorInputField] = useState(false);
  const [openPopup, setOpenPopup] = useState(false);
  const navigate = useNavigate();
  const [showProgress, setShowProgress] = useState(false);
  const [copyPrevSettings, setCopyPrevSettings] = useState(true);
  const skillsData = useSelector((state) => state.initialData.skills);
  const difficulty_levelData = useSelector(
    (state) => state.initialData.difficultyLevels,
  );
  const timeTableSessionId = JSON.parse(
    localStorage.getItem("timeTableSessionId"),
  );
  const academicSessionId = JSON.parse(
    localStorage.getItem("academicYearSessionId"),
  );
  //Added this state by kuldeep
  const { state } = useLocation();
  const [assessmentDetails, setAssessmentDetails] = useState({
    id: null,
    name: null,
    description: null,
    teacher_id: null,
    type_id: null,
    standard_id: null,
    section_id: null,
    subject_id: null,
    tags: [],
    status: null,
    total_duration: null,
    schedule_date: null,
    schedule_time: null,
    add_to_live_session: null,
    questions: [],
    deadline: null,
  });
  const {
    standard_id,
    subject_id,
    section_id,
    total_duration,
    name,
    description,
    deadline,
  } = assessmentDetails;
  const [click, setClick] = useState(false);
  const [questions, setQuestions] = useState([]);

  useEffect(() => {
    if (!questions || questions.length === 0) return;

    // check agar koi question edited hai
    const hasEdited = questions.some((q) => q.is_question_edited);

    if (!hasEdited) return; // ❌ agar edited nahi hai toh save mat kar

    setTimeout(() => {
      localStorage.setItem(
        `DraftQHomeWorkLocal-${state.homework_id}`,
        JSON.stringify(questions),
      );
    }, 500);
  }, [questions]);

  const getAssessment = async () => {
    let res = await axios.get(`/api/v1/homework/get/${state.homework_id}`);
    if (res) {
      const {
        id,
        name,
        description,
        teacher_id,
        type_id,
        subject_id,
        section_id,
        standard_id,
        tags,
        total_duration,
        deadline,
      } = res?.data?.data;

      setAssessmentDetails((prev) => ({
        ...prev,
        id,
        name,
        description,
        teacher_id: teacher_id?.id,
        type_id: type_id?.id,
        subject_id,
        section_id,
        standard_id,
        tags,
        total_duration,
        deadline,
      }));

      if (state?.localData) {
        const localSaved = JSON.parse(
          localStorage.getItem(`DraftQHomeWorkLocal-${state.homework_id}`) ||
            "{}",
        );
        if (localSaved) {
          setQuestions(localSaved);
          return; // stop yahin
        }
      }
      console.log("no localDAta hai");

      res.data.data.questions.map((question) =>
        setQuestions((prev) => [
          ...prev,
          {
            standard_id: question?.standard?.id,
            subject_id: question?.subject?.id,
            section_id: question?.section?.id,
            book_id: question?.book?.id,
            chapter_id: question?.chapter?.id,
            type_id: question?.type?.id,
            question_type: String(question?.type?.is_manually_graded),
            domain_id: question?.domain?.id,
            skill_id: question?.skill?.id,
            difficulty_level: question?.difficulty_level?.id,
            title: question?.title,
            correct_score: question?.correct_score,
            is_mandatory: question?.is_mandatory,
            add_to: question?.add_to,
            add_to_mock: question?.add_to_mock,
            attachments: question?.attachments,
            options: question?.options,
            correct_answers: question?.correct_answers,
          },
        ]),
      );
    }
  };

  useEffect(() => {
    getAssessment();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getBaseQuestionTemplate = () => ({
    standard_id: standard_id ? standard_id?.id : null,
    subject_id: subject_id ? subject_id?.id : null,
    section_id: section_id ? section_id?.id : null,
    book_id: "",
    chapter_id: null,
    question_type: "null",
    type_id: null,
    domain_id: null,
    skill_id: null,
    difficulty_level: null,
    title: null,
    correct_score: null,
    is_mandatory: false,
    add_to: null,
    add_to_mock: false,
    attachments: [],
    options: [
      { key: "A", value: null },
      { key: "B", value: null },
      { key: "C", value: null },
      { key: "D", value: null },
    ],
    correct_answers: [
      {
        option_key: null,
        value: null,
        reason_for_answer: {
          attachment: null,
          explanation: null,
        },
      },
    ],
  });

  const addMoreQuestion = () => {
    setQuestions((prev) => {
      const baseQuestion = getBaseQuestionTemplate();

      if (copyPrevSettings && prev.length > 0) {
        const previous = prev[prev.length - 1];

        const isMCQ = previous.question_type === "false";

        return [
          ...prev,
          {
            ...baseQuestion,

            // 🔁 copied metadata
            book_id: previous.book_id,
            chapter_id: previous.chapter_id,
            skill_id: previous.skill_id,
            domain_id: previous.domain_id,
            difficulty_level: previous.difficulty_level,
            correct_score: previous.correct_score,

            // 🔥 IMPORTANT: sync question type properly
            type_id: previous.type_id,
            question_type: previous.question_type,

            // 🔥 THIS IS THE KEY FIX
            options: isMCQ
              ? [
                  { key: "A", value: null },
                  { key: "B", value: null },
                ]
              : [],

            correct_answers: isMCQ
              ? [
                  {
                    option_key: null,
                    value: null,
                    reason_for_answer: {
                      attachment: null,
                      explanation: null,
                    },
                  },
                ]
              : [
                  {
                    reason_for_answer: {
                      explanation: null,
                      attachments: null,
                    },
                  },
                ],
          },
        ];
      }

      return [...prev, baseQuestion];
    });
  };

  const checkAllDataField = () => {
    let hasError = false;

    questions.forEach((question, index) => {
      if (!question.title) {
        setGetErrorMsg(`Title missing in question ${index + 1}`);
        hasError = true;
      }
      if (!question.skill_id) {
        setGetErrorMsg(`Skill missing in question ${index + 1}`);
        hasError = true;
      }
      // if (question.skill_id) {
      //   const noneLevel = skillsData.find(
      //     (lvl) => lvl.name?.toLowerCase() === "none"
      //   );

      //   if (noneLevel && question?.skill_id === noneLevel.id) {
      //     setGetErrorMsg(`Skills should not be "None" in question ${index + 1}`);
      //     hasError = true;
      //   }
      // }
      if (!question.type_id) {
        setGetErrorMsg(`Question Type missing in question ${index + 1}`);
        hasError = true;
      }
      if (!question.chapter_id) {
        setGetErrorMsg(`Book & Chapter missing in question ${index + 1}`);
        hasError = true;
      }
      if (!question.correct_score) {
        setGetErrorMsg(`Correct Score missing in question ${index + 1}`);
        hasError = true;
      }
      if (!question.difficulty_level) {
        setGetErrorMsg(`Difficulty Level missing in question ${index + 1}`);
        hasError = true;
      }

      if (componentType === ComponentType.QUESTION_BANK) {
        if (
          !question?.add_to ||
          question.add_to === null ||
          question.add_to.trim() === ""
        ) {
          setGetErrorMsg(`Add to missing in question ${index + 1}`);
          hasError = true;
        }
      }
      if (Array.isArray(question.options) && question.options.length > 0) {
        question.options.forEach((opt, optIndex) => {
          if (!opt?.key || opt.key.trim() === "") {
            setGetErrorMsg(`Option key missing in question ${index + 1}`);
            hasError = true;
          }
          if (!opt?.value || opt.value.trim() === "") {
            setGetErrorMsg(`Option value missing in question ${index + 1}`);
            hasError = true;
          }
        });
      }

      if (Array.isArray(question.correct_answers)) {
        question?.correct_answers?.forEach((ans, ansIndex) => {
          if (question?.options?.length > 0) {
            if (!ans?.option_key || ans?.option_key.trim() === "") {
              setGetErrorMsg(`Option key missing in question ${index + 1}`);
              hasError = true;
            }
          }
        });
      }
    });
    if (hasError) {
      setShowErrorInputField(true);
      return true;
    }

    return false;
  };

  const findDuplicateQuestions = () => {
    const idMap = new Map();
    const titleMap = new Map();
    const duplicatePairs = [];

    questions.forEach((q, index) => {
      const id = q.id || q.b4sQuestion;
      const title = q.title?.trim()?.toLowerCase();

      // ✅ ID based duplicate
      if (id) {
        if (idMap.has(id)) {
          duplicatePairs.push([idMap.get(id), index + 1]);
        } else {
          idMap.set(id, index + 1);
        }
      }

      // ✅ Title based duplicate (manual case)
      if (title) {
        if (titleMap.has(title)) {
          duplicatePairs.push([titleMap.get(title), index + 1]);
        } else {
          titleMap.set(title, index + 1);
        }
      }
    });

    if (duplicatePairs.length > 0) {
      const formatted = duplicatePairs
        .map(([q1, q2]) => `Q${q1} ↔ Q${q2}`)
        .join("\n");

      setViewErrorMsg(`Duplicate questions found:\n${formatted}`);
      isSetOpenPopupDupli(true);
      return true;
    }

    isSetOpenPopupDupli(false);
    return false;
  };

  console.log("viewErrorMsg", viewErrorMsg);
  console.log("isopenPopupDupli", isopenPopupDupli);

  const handleCreateAssessment = async () => {
    console.log("handle create called");

    const isHeavyAssessment = questions.length > 20;

    if (isHeavyAssessment) {
      setShowProgress(true);
    } else {
      setIsLoading(true);
    }
    let newAssessment = {
      name: assessmentDetails.name,
      description: assessmentDetails.description,
      type_id: assessmentDetails.type_id,
      standard_id: assessmentDetails.standard_id?.id,
      subject_id: assessmentDetails.subject_id?.id,
      teacher_id: assessmentDetails.teacher_id,
      section_id: assessmentDetails.section_id?.id,
      academic_session_id: academicSessionId,
      timetable_session_id: timeTableSessionId,
      tags: assessmentDetails.tags,
      status: "draft",
      total_duration: assessmentDetails.total_duration,
      questions: questions,
    };

    try {
      let res = await axios.put(
        `/api/v1/homework/update/${assessmentDetails?.id}`,
        newAssessment,
      );
      res && navigate("/PublishedHomework");
    } catch (error) {
      setIsInProgress(false);
    } finally {
      localStorage.removeItem(`DraftQHomeWorkLocal-${state.homework_id}`);
      setShowProgress(false);
      setIsInProgress(false);
    }
  };
  function formatDate(inputDate) {
    if (!inputDate || inputDate == undefined) {
      return `--/--/---- - 00:00`;
    }
    const date = new Date(inputDate);

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12;

    return `${day}/${month}/${year} - ${hours}:${minutes} ${ampm}`;
  }

  const findTotalMarks = () => {
    if (questions)
      return questions?.reduce(
        (acc, curr) => acc + Number(curr.correct_score),
        0,
      );
  };

  useEffect(() => {
    const dataCounter = {
      Skills: {},
      DifficultyLevel: {},
      QuestionType: {},
    };
    questions.map((item, index) => {
      const correctScore = Number(item.correct_score);
      if (item.question_type !== null) {
        if (dataCounter["QuestionType"][item.question_type] === undefined) {
          dataCounter["QuestionType"][item.question_type] = correctScore;
        } else {
          setCountDifficulty({});
          dataCounter["QuestionType"][item.question_type] += correctScore;
        }
      }
      if (item.question_type !== null) {
        if (dataCounter["Skills"][item.skill_id] === undefined) {
          dataCounter["Skills"][item.skill_id] = correctScore;
        } else {
          dataCounter["Skills"][item.skill_id] += correctScore;
        }
      }
      if (item.question_type !== null) {
        if (
          dataCounter["DifficultyLevel"][item.difficulty_level] === undefined
        ) {
          dataCounter["DifficultyLevel"][item.difficulty_level] = correctScore;
        } else {
          dataCounter["DifficultyLevel"][item.difficulty_level] += correctScore;
        }
      }
    });

    setCountQsType(dataCounter);
    setCountSkills(dataCounter);
    setCountDifficulty(dataCounter);
    // question_type,skill_id,difficulty_level
  }, [questions]);
  return (
    <>
      <UpdateQuestions
        operationType={OperationType.UPDATE}
        setClickFromCreate={setClick}
        assessmentDetails={assessmentDetails}
        setAssessmentDetails={setAssessmentDetails}
        componentType={componentType}
        questions={questions}
        setQuestions={setQuestions}
        addMoreQuestion={addMoreQuestion}
        checkAllDataField={checkAllDataField}
        findTotalMarks={findTotalMarks}
        handleCreateAssessment={handleCreateAssessment}
        isloading={isloading}
        setIsChecked={setIsChecked}
        getErrorMsg={getErrorMsg}
        openPopupDupli={openPopupDupli}
        viewErrorMsg={viewErrorMsg}
        hidePopupCheck={hidePopupCheck}
        showErrorInputField={showErrorInputField}
        findDuplicateQuestions={findDuplicateQuestions}
        setShowErrorInputField={setShowErrorInputField}
        setOpenPopup={setOpenPopup}
        openPopup={openPopup}
        isSetOpenPopupDupli={isSetOpenPopupDupli}
        isopenPopupDupli={isopenPopupDupli}
        copyPrevSettings={copyPrevSettings}
        setCopyPrevSettings={setCopyPrevSettings}
      />
      {showProgress && (
        <Dialog open={true} maxWidth="xs" fullWidth>
          <DialogContent
            sx={{
              textAlign: "center",
              py: 4,
            }}
          >
            {/* Loader */}
            <Box sx={{ mb: 2 }}>
              <div className="spinner-border text-primary" />
            </Box>

            {/* Title */}
            <Typography variant="h6" fontWeight="bold" gutterBottom>
              Saving Homework as Draft...
            </Typography>

            {/* Message */}
            <Typography variant="body2" color="text.secondary">
              Please wait ⏳
              <br />
              This may take a 1-2 minutes due to large number of questions.
            </Typography>
          </DialogContent>
        </Dialog>
      )}
    </>
  );
}
